import {
  enUS,
  da,
  de,
  enCA,
  enGB,
  enIE,
  fr,
  frCA,
  it,
  ja,
  nb,
  nlBE,
  nl,
  sv,
  arMA,
} from "date-fns/locale";

const adapterLanguage = [
  {
    code: "ar-MA",
    lan: arMA,
  },
  {
    code: "en-US",
    lan: enUS,
  },
  {
    code: "en-GB",
    lan: enGB,
  },
  {
    code: "fr-BE",
    lan: fr,
  },
  {
    code: "nl-BE",
    lan: nlBE,
  },
  {
    code: "nl-NL",
    lan: nl,
  },
  {
    code: "de-DE",
    lan: de,
  },
  {
    code: "fr-CA",
    lan: frCA,
  },
  {
    code: "en-IE",
    lan: enIE,
  },
  {
    code: "ja-JP",
    lan: ja,
  },
  {
    code: "it-IT",
    lan: it,
  },
  {
    code: "nb-NO",
    lan: nb,
  },
  {
    code: "da-DK",
    lan: da,
  },
  {
    code: "fr-FR",
    lan: fr,
  },
  {
    code: "en-CA",
    lan: enCA,
  },
  {
    code: "sv-SE",
    lan: sv,
  },
];

export default adapterLanguage;
